import { PropsWithChildren } from 'react';
import { useDisclosure } from '../../../lib/hooks';
import { AddCertificatePanelContext } from './context';
import AddCertificatePanel from './AddCertificatePanel';

const AddCertificatePanelProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const panel = useDisclosure();

  return (
    <AddCertificatePanelContext value={panel}>
      {<AddCertificatePanel isOpen={panel.isOpen} close={panel.close} />}
      {children}
    </AddCertificatePanelContext>
  );
};

export default AddCertificatePanelProvider;
